import styles from './ua.module.scss'
import { PLACEHOLDER_IMAGE, conditionLabel, detailPageUrl, inventoryPhotoUrl } from '@/data/Inventory'
import { formatCurrency, formatNumber } from '@/utils/Formatters'
import Button from '@/components/button/Button'
import { calcFinancePayment, disclaimer, getDefaultAPR } from '@/utils/DR'
import FavoriteButton from '../vehicle/FavoriteButton'
import Tile from '@/components/tile/Tile'
import TileHeroImage from '@/components/tile/TileHeroImage'
import TileInfo from '@/components/tile/TileInfo'
import TileTopButtons from '@/components/tile/TileTopButtons'
import VisibilityPixel from '@/components/plugins/VisibilityPixel'
import InvTileAd from '../ads/InvTileAd'
import RecentlyViewedBadge from '../vehicle/RecentlyViewedBadge'
import { strings } from '@/utils/I18n'

export default function InventoryTile(props) {
  
  const site = props.site
  const item = props.item
  
  const creditTier = props.budget?.creditTier ? site.dr.credit_tiers.filter(e => parseInt(e.tier) == parseInt(props.budget?.creditTier))[0] : site.session.credit_tier
  const apr = (site.dr && creditTier ? getDefaultAPR(item, creditTier) : 0)
  const tradeInValue = props.budget?.tradeInValue || site.budget?.tradeInValue || 0
  const tradeInPayoff = props.budget?.tradeInPayoff || site.budget?.tradeInPayoff || 0
  const financeTerm = props.budget?.term || site.budget?.term || site.dr?.finance.term
  const cashDown = props.budget?.cashDown || site.budget?.cashDown || site.dr?.default_cash_down
  const payment = { 
    monthly: site.dr && creditTier ? calcFinancePayment(item.prices.price || item.prices.msrp, apr, financeTerm, cashDown, tradeInValue, tradeInPayoff) : null,
    price: item.prices.price || item.prices.msrp, 
    apr: apr, 
    term: financeTerm, 
    trade: tradeInValue,
    down: cashDown
  }

  const photoUrl = inventoryPhotoUrl(site, item)
  const vdpUrl = detailPageUrl(item)

  return (
    <>
    { props.ad &&
      <InvTileAd {...props}></InvTileAd>
    }
    <Tile key={item.vin}>
      <TileHeroImage link={vdpUrl} priority={props.index < 2} image={photoUrl} flipH={item.photos?.stock_image == photoUrl} placeholder={PLACEHOLDER_IMAGE} alt={item.full_name} objectFit="fill"></TileHeroImage>
      <TileInfo link={vdpUrl} alt={item.full_name}>
        <div>
          <div className={'text-sm text-primary'}>{ conditionLabel(item.condition) }</div>
          <div className={'text-bold'}>{ item.year + ' ' + item.make_name + ' ' + item.model_name }</div>
          <div className={''}>{ '#' + item.stock_number + ' | ' +item.trim_name + ' | ' + formatNumber(item.mileage) + ' miles' }</div>
        </div>
        <div>
          <div>
          { (item.prices.price || item.prices.msrp) > 0 ?
          <>
            <div className={'flex-col flex-stretch text-bold'}>{ formatCurrency(item.prices.price || item.prices.msrp) }</div>
            { payment.monthly &&
            <div className={'flex-col'}>
              <div>Est. <span className={'text-primary text-bold ' + styles.tooltip} data-title={ disclaimer(site, 'finance', payment) }>{ formatCurrency( payment.monthly ) }</span><span className='text-sm'>/mo</span></div>
            </div>
            }
            </>
          :
            <Button mapping="lead-form" theme="none" data={ item.vin } label={ strings(props.site)['srp_zeroPriceLinkLabel'] || 'Contact us for price >' }></Button>
          }
          </div>
        </div>
      </TileInfo>
      <TileTopButtons>
        <RecentlyViewedBadge {...props} vin={item.vin}></RecentlyViewedBadge>
        <FavoriteButton site={site} vin={item.vin} favs={props.favs} id={item.id}></FavoriteButton>
      </TileTopButtons>
      <VisibilityPixel {...props} track="srtv" name={"vin: " + item.vin} data={{ vin: item.vin, name: item.full_name }}><></></VisibilityPixel>
      <VisibilityPixel {...props} track="srtmk" name={"make: " + item.make_name} data={{ vin: item.vin, name: item.full_name }}><></></VisibilityPixel>
      <VisibilityPixel {...props} track="srtmd" name={"model: " + item.model_name} data={{ vin: item.vin, name: item.full_name }}><></></VisibilityPixel>
    </Tile>
    </>
  )
  
  
}
